'use strict';

export default class SearchSwitch extends React.Component {
    render() {
        const {type, planesCount, seatsCount, onChangeType} = this.props;
        return <div className="switcher">
            <a onClick={() => onChangeType('planes')} className={clsx({active: type === 'planes'})}>
                <span>
                    {tMsg2('search.planes.title')}{planesCount > 0 && <i>{planesCount}</i>}
                </span>
            </a>
            <a onClick={() => onChangeType('seats')} className={clsx({active: type === 'seats'})}>
                <span>
                    {tMsg('Места')}{seatsCount > 0 && <i>{seatsCount}</i>}
                </span>
            </a>
        </div>
    }
}